import { Component, Input, OnInit } from "@angular/core";
import {
  ControlContainer,
  UntypedFormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";

import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
@Component({
    selector: "app-limit",
    templateUrl: "./limit.component.html",
    styleUrls: ["./limit.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class DataLimitComponent implements OnInit {
  childForm: any;

  @Input() currentDataFields!: any;
  @Input() chartType!: any;
  public aggregateData: any = [];

  constructor(
    public parentF: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private canvasService: CanvasService,
    public commonService: CommonService
  ) {}

  buildAggregateData(event: any) {
    // make refresh call and emit the chart data to the parent

    const dataLimitError = this.childForm.get("dataLimit").hasError("min");
    if (!dataLimitError) {
      this.canvasService.refreshCanvas(this.childForm).subscribe(
        (success: any) => {
          this.canvasService.triggerEnable();
          const data = success.data;
          this.canvasService.pushChartToStorage(data);
          this.canvasService.populateCanvas(data);
        },
        (error: any) => {
          this.canvasService.triggerEnable();
          const data = this.canvasService.getChartFromStorage();
          this.canvasService.populateCanvas(data);
        }
      );
    }
  }

  ngOnChanges() {}
  ngOnInit(): void {
    this.childForm = this.parentF.form;
  }
}
